import { APIClient } from "./_api";

const endpoint = "/Blog";

export function getAllBlog() {
  return APIClient.get(`${endpoint}`);
}

export function getThisBlog(id) {
  return APIClient.get(`${endpoint}/${id}`);
}

export function getAllBlogTree() {
  return APIClient.get(`${endpoint}/tree`);
}

export function addBlog(data) {
  let bodyFormData = new FormData();
  for (let key in data) {
    bodyFormData.append(key, data[key]);
  }
  return APIClient.post(`${endpoint}`, bodyFormData);
}

export function editBlog(data, id) {
  // let bodyFormData = new FormData();
  // for (let key in data) {
  //   bodyFormData.append(key, data[key]);
  // }
  return APIClient.put(`${endpoint}/${id}`, data);
}

export function deleteBlog(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}
